import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["query", "spinner", "summary", "resultsStatus"]

  connect() {
    this.timeoutId = null
    this.lastSubmittedSignature = this.signature()
    this.hideSpinner()
  }

  disconnect() {
    if (this.timeoutId) window.clearTimeout(this.timeoutId)
  }

  queueSearch() {
    if (this.timeoutId) window.clearTimeout(this.timeoutId)

    const query = this.queryTarget.value.trim()
    if (query.length > 0 && query.length < 3) {
      this.hideSpinner()
      return
    }

    this.timeoutId = window.setTimeout(() => {
      this.submitIfChanged()
    }, 300)
  }

  submitNow() {
    if (this.timeoutId) window.clearTimeout(this.timeoutId)
    this.submitIfChanged()
  }

  showSpinner() {
    if (!this.hasSpinnerTarget) return

    this.spinnerTarget.hidden = false
    if (this.hasSummaryTarget) this.summaryTarget.hidden = true
    if (this.hasResultsStatusTarget) this.resultsStatusTarget.setAttribute("aria-busy", "true")
  }

  hideSpinner() {
    if (!this.hasSpinnerTarget) return

    this.spinnerTarget.hidden = true
    if (this.hasSummaryTarget) this.summaryTarget.hidden = false
    if (this.hasResultsStatusTarget) this.resultsStatusTarget.setAttribute("aria-busy", "false")
  }

  submitIfChanged() {
    const nextSignature = this.signature()
    if (nextSignature === this.lastSubmittedSignature) return

    this.lastSubmittedSignature = nextSignature
    this.element.requestSubmit()
  }

  signature() {
    return JSON.stringify({
      q: this.queryTarget.value.trim(),
      load_all: this.element.querySelector("input[type=checkbox][name='load_all']")?.checked || false,
      tenant_id: this.element.querySelector("[name='tenant_id']")?.value.toString() || "",
      tenant_role_id: this.element.querySelector("[name='tenant_role_id']")?.value.toString() || "",
      membership_type_id: this.element.querySelector("[name='membership_type_id']")?.value || "",
      venue_id: this.element.querySelector("[name='venue_id']")?.value.toString() || "",
      tournament_gender: this.element.querySelector("[name='tournament_gender']")?.value || "",
      pirat_min: this.element.querySelector("[name='pirat_min']")?.value || "",
      pirat_max: this.element.querySelector("[name='pirat_max']")?.value || "",
      dupr_min: this.element.querySelector("[name='dupr_min']")?.value || "",
      dupr_max: this.element.querySelector("[name='dupr_max']")?.value || "",
      age_min: this.element.querySelector("[name='age_min']")?.value || "",
      age_max: this.element.querySelector("[name='age_max']")?.value || "",
      platform_users_only: this.element.querySelector("input[type=checkbox][name='platform_users_only']")?.checked || false,
      show_active_members: this.element.querySelector("input[type=checkbox][name='show_active_members']")?.checked || false,
      financial_members: this.element.querySelector("input[type=checkbox][name='financial_members']")?.checked || false,
      recently_active_members: this.element.querySelector("input[type=checkbox][name='recently_active_members']")?.checked || false,
      deleted_users_only: this.element.querySelector("input[type=checkbox][name='deleted_users_only']")?.checked || false
    })
  }
}
